import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { SpectrogramCsvUpload, SpectrogramUploadResult } from '@ledium/ui-common';
import { FormHelperText, Grid } from '@mui/material';

const LightChannelCsvUploadButton = () => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function onCsvUpload(csvData: SpectrogramUploadResult) {
        pageActions.formData.updateFormItem({ csvData: csvData.rawCsv });
        pageActions.formData.updateFormItem({ spectrogram: csvData.spectrogram });
        pageActions.formData.updateFormItem({ spectrogramRanges: csvData.ranges });
    }

    const spectrogram = formData.spectrogram as unknown[];

    return (
        !formData.readOnly && (
            <Grid item xs={12}>
                <SpectrogramCsvUpload onUpload={onCsvUpload} />
                {!spectrogram.length && !!formData.isSubmitted && (
                    <FormHelperText sx={{ color: 'error.main' }}>{i18n('you_should_upload_a_valid_spectrogram_csv_file_before_save')}</FormHelperText>
                )}
            </Grid>
        )
    );
};

export default LightChannelCsvUploadButton;
